import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { AppProxy } from "./lib/AppProxy";
import { registerServiceWorker } from './serviceWorkerRegistration';
import { PreloaderContextProvider } from "./lib/context/PreloaderContext";

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
        <PreloaderContextProvider>
            <AppProxy />
        </PreloaderContextProvider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
registerServiceWorker();
